import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import {
  USER_STATUS_ACTIVE,
  USER_STATUS_INACTIVE,
} from "../store/User/UserConstant";

import { Badge } from "@mui/material";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      background: "#00a65a",
      color: "#FFF",
      padding: "4px 10px",
    },
    inactive: {
      background: "#dd4b39",
      color: "#FFF",
      padding: "4px 10px",
    },
  })
);

const UserStatus = (props: any) => {
  const classes = useStyles();
  const { value } = props;

  if (value === USER_STATUS_ACTIVE) {
    return (
      <Badge badgeContent="Активен" classes={{ badge: classes.active }}></Badge>
    );
  }

  if (value === USER_STATUS_INACTIVE) {
    return (
      <Badge
        badgeContent="Не&nbsp;активен"
        classes={{ badge: classes.inactive }}
      ></Badge>
    );
  }

  return <>&nbsp;</>;
};

export default UserStatus;
